import { reduce } from "et3-type-guards";

import Et3Button from "../../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import SilentBanButton from "../../../../../../core/et3-shared-components/action-buttons/SilentBanButton";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";

const SilentBanActionButton = withLiteObserverAndTheme(() => {
  const advancedStore = getUserAdvancedStore();
  const userID = advancedStore.currentUserId.get();
  const userUUID = reduce(
    () => advancedStore.userData.get(userID).userUUID,
    ""
  );
  const isSilentBanned = advancedStore.isSilentBanned.get();
  const isDisabled = advancedStore.isSilentBanActionDisabled.get();

  return isSilentBanned ? (
    <Et3Button
      isEnabled={!isDisabled}
      onClick={() => {
        getCorePopUpStore().openConfirmationPopUps("REMOVE_SILENT_BAN_POPUP");
      }}
      size="MEDIUM"
      text="REMOVE_SILENT_BAN"
      type="GET"
    />
  ) : (
    <SilentBanButton
      fromPage="USER_ADVANCED"
      extraData={{
        userID,
        userUUID,
        reportedUUID: "",
        reportID: -1,
        reportedID: -1,
        secondPartyID: -1
      }}
      disabled={isDisabled}
      size="MEDIUM"
    />
  );
});
export default SilentBanActionButton;
